import React, { useContext } from 'react';

import { OnAirContetns } from '../../styles/onAirStyles';
import { LayoutContext } from '../../context/layoutContext';
import { textSilce } from '../../constants/index';

const OnAirComponent = ({ data, active }) => {
  const { matchese } = useContext(LayoutContext);

  let aP = 'AM';

  let time = Number(`${data?.time.split(':')[0]}${data?.time.split(':')[1]}`);
  if (time > 1200 && time < 2400) aP = 'PM';

  return (
    <OnAirContetns active={active} gauge={data?.gauge}>
      {matchese && <h2>실시간 TV</h2>}
      <h1>{`${textSilce(data?.program?.title, 15)} ${matchese ? `${data?.episode?.episodeNo ? data?.episode?.episodeNo : ''}` : ''}`}</h1>
      <span />
      <h3>{`${aP} ${data?.time}`}</h3>
      <p>{data?.episode?.episodeNo && `${data?.episode?.episodeNo}화`}</p>
      <p>{data?.episode?.title ? data?.episode?.title : ''}</p>
      {data?.status === 'live' && <div>본</div>}
    </OnAirContetns>
  );
};

export default OnAirComponent;
